export const environment = {
  production: false,
  apiAuth: 'http://localhost:7071/api/v1',
  apiAccounts: 'http://localhost:7070/api/v1',
};
